//权限管理
import http from '../jslibs/axios/http';

// 权限管理 用户列表
export const getAuthList = data => http.get('/cms/Admin', data);

// 权限管理 新增用户http://127.0.0.1:18806/admin/admin.admin/addAdminItem
export const addAdminUser = data => http.post('/cms/Admin', data);
//编辑管理员
export const updateAdminUser = data => http.put('/cms/Admin/' + data.uuid, data);
//管理员详情
export const getAdminUserDetail = data => http.get('/cms/Admin/' + data.uuid);
//删除管理员
export const deleteAdminUser = data => http.delete('/cms/Admin/' + data.uuid);


//角色列表
export const getAdminRoleList = data => http.get('/cms/AdminRole', data);
//删除角色
export const deleteAdminRole = data => http.delete('/cms/AdminRole/' + data.uuid);
// 添加角色
export const addAdminRole = data => http.post('/cms/AdminRole', data);
//编辑菜单
export const updateAdminRole = data => http.put('/cms/AdminRole/' + data.uuid, data);
//管理员详情
export const getAdminRoleDetail = data => http.get('/cms/AdminRole/' + data.uuid);


//菜单列表
export const getAdminMenu = data => http.get('/cms/AdminMenu', data);
//删除菜单
export const deleteAdminMenu = data => http.delete('/cms/AdminMenu/' + data.uuid);
//添加菜单
export const addAdminMenu = data => http.post('/cms/AdminMenu', data);
//编辑菜单
export const updateAdminMenu = data => http.put('/cms/AdminMenu/' + data.uuid, data);

//日志列表
export const getAdminLog = data => http.get('/cms/AdminLog', data);
//日志一级菜单
export const getAdminLogMenu = data => http.get('/cms/AdminLogMenu', data);
//日志二级菜单
export const getAdminLogSubMenu = data => http.get('/cms/AdminLogSubMenu', data);
//日志详情
export const getAdminLogDetail = data => http.get('/cms/AdminLog/' + data.uuid);